import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { ConfigServiceProvider } from '../config-service/config-service';
import { PlayerServiceProvider } from '../player-service/player-service';
import { MapOfNumberTo } from '../../../ranking/interfaces/utils';
import { UserGroup } from '../users-service/interfaces/user-group.interface';

// todo: refactor
@Injectable()
export class UserGroupsServiceProvider {
  filteredGroups = [];
  allTerritorialGroups = [];
  groups;
  groupsConfig;
  player;
  iconsToGroups;
  userGroups;
  playerGroups;
  newsGroups;
  accountRoles: string[];

  constructor(
    public http: HttpClient,
    private storageService: StorageServiceProvider,
    private configService: ConfigServiceProvider,
    private playerService: PlayerServiceProvider,
  ) {}

  load() {
    return new Promise((resolve, reject) => {
      Promise.all([
        this.http.get(this.configService.getUrl('userGroupsConfig')).toPromise(),
        this.http.get(this.configService.getUrl('groups')).toPromise(),
        this.playerService.getPlayer(),
        this.playerService.getAccountRoles(),
      ]).then((response: any) => {
        this.filteredGroups = [];
        this.allTerritorialGroups = [];
        this.accountRoles = response[3];
        this.groups = response[1];
        this.groupsConfig = response[0].params.usersTypesToGroups;
        this.player = response[2];
        this.iconsToGroups = response[0].params.iconsToGroups;

        this.userGroups = this.player.userGroups;

        this.userGroups.forEach((group) => {
          if (group.params.groupType === 'TERRITORIAL') this.filteredGroups.push(group);
        });

        for (var key in this.groups) {
          if (this.groups[key].params.groupType === 'TERRITORIAL') this.allTerritorialGroups.push(this.groups[key]);
        }

        if (this.groupsConfig.hasOwnProperty(this.player.params.type)) {
          this.playerGroups = this.groupsConfig[this.player.params.type];

          this.playerGroups.forEach((group) => {
            if (
              this.groups.hasOwnProperty(group) &&
              this.filteredGroups
                .map((item) => {
                  return item.id;
                })
                .indexOf(this.groups[group].id) === -1
            ) {
              this.filteredGroups.push(this.groups[group]);
            }
          });
        }

        //TODO do wywalenia? Nie ma użyć, ale do sprawdzenia jak na innych środowiskach
        if (
          this.accountRoles.findIndex((priority) => {
            return priority == 'ROLE_NEWS_EDITOR';
          }) > -1
        ) {
          this.newsGroups = this.filteredGroups.filter((group) => {
            return this.player.userGroups.find((userGroup) => {
              return userGroup.id == group.id || group.params.parent == 8;
            });
          });
        }
        this.filteredGroups = this.filteredGroups.sort(function (a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });

        this.storageService.setObject('userGroups', this.userGroups);
        this.storageService.setObject('iconsToGroups', this.iconsToGroups);
        this.storageService.setObject('allTerritorialGroups', this.allTerritorialGroups);
        this.storageService.setObject('allGroups', this.groups);
        return this.storageService.setObject('filteredGroups', this.filteredGroups);
      }, reject);
    });
  }

  getAllGroups(): Promise<MapOfNumberTo<UserGroup>> {
    return this.storageService.getObject('allGroups');
  }

  getGroupsForUserType() {
    return this.storageService.getObject('filteredGroups');
  }

  getUserGroups() {
    return this.storageService.getObject('userGroups');
  }

  getIconthiStoGroups() {
    return this.storageService.getObject('iconsToGroups');
  }

  getAllTerritorialGroups() {
    return this.storageService.getObject('allTerritorialGroups');
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/user-groups-service/user-groups-service.ts